import { createFocusOutlineStyle } from '@fluentui/react-tabster';
import { tokens } from '@fluentui/react-theme';
import { __styles, mergeClasses, shorthands } from '@griffel/react';
export const radioClassNames = {
  root: 'fui-Radio',
  indicator: 'fui-Radio__indicator',
  input: 'fui-Radio__input',
  label: 'fui-Radio__label'
}; // The indicator size is used by the indicator and label styles

const indicatorSize = '16px';
/**
 * Styles for the root slot
 */

const useRootStyles = /*#__PURE__*/__styles({
  "base": {
    "mc9l5x": "ftuwxu6",
    "qhf8xq": "f10pi13n"
  },
  "vertical": {
    "Beiy3e4": "f1vx9l62",
    "Bt984gj": "f122n59"
  },
  "focusIndicator": {
    "Brovlpu": "ftqa4ok",
    "B486eqv": "f2hkw1w",
    "n9p9qa": "f1fu8s9w",
    "B0otyzi": ["f8rbx7c", "f1jcuzx9"],
    "r10ruj": "f1c1apvh",
    "Bk2vswc": ["f1jcuzx9", "f8rbx7c"],
    "gjlbkn": "fyrlc8h",
    "B1kt0iq": "f28z38y",
    "Boi8ppg": "f1edqc4x",
    "Btfhvw2": "f19bnj08",
    "B55xfkk": "f17wg1r9",
    "i1dkbe": ["fgiioun", "fnx45sh"],
    "Bozs2tv": "f1ljqnps",
    "snkem8": ["fnx45sh", "fgiioun"],
    "Bjilewg": "fsacsau",
    "wht04d": ["flcxmxr", "f138axrn"],
    "vikdft": "f1f4bc3q",
    "Bwdhxlo": ["f138axrn", "flcxmxr"],
    "B167d6d": ["f5m7f7q", "f175edhc"],
    "Bpdw69r": ["f175edhc", "f5m7f7q"],
    "Bsdv7io": ["fhfahiz", "fnreirl"],
    "Bd353ur": ["fnreirl", "fhfahiz"],
    "Bcnuwmc": "fn9i64i",
    "dyfsa2": ["f1pylbqb", "f3dy9ja"],
    "Bdcx1rh": "f1v06qdr",
    "Bbd0xgj": ["f3dy9ja", "f1pylbqb"],
    "Bbretkc": "fm1yk70",
    "rnyfg7": "f1itvegt",
    "Bg18gms": ["f17e4q3j", "foxjjqz"],
    "Bym00rn": ["foxjjqz", "f17e4q3j"]
  }
}, {
  "d": [".ftuwxu6{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;}", ".f10pi13n{position:relative;}", ".f1vx9l62{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}", ".f122n59{-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}", ".f1fu8s9w[data-fui-focus-visible]:focus-within{border-top-color:transparent;}", ".f8rbx7c[data-fui-focus-visible]:focus-within{border-right-color:transparent;}", ".f1jcuzx9[data-fui-focus-visible]:focus-within{border-left-color:transparent;}", ".f1c1apvh[data-fui-focus-visible]:focus-within{border-bottom-color:transparent;}", ".fyrlc8h[data-fui-focus-visible]:focus-within::after{content:\"\";}", ".f28z38y[data-fui-focus-visible]:focus-within::after{position:absolute;}", ".f1edqc4x[data-fui-focus-visible]:focus-within::after{pointer-events:none;}", ".f19bnj08[data-fui-focus-visible]:focus-within::after{z-index:1;}", ".f17wg1r9[data-fui-focus-visible]:focus-within::after{border-top-style:solid;}", ".fgiioun[data-fui-focus-visible]:focus-within::after{border-right-style:solid;}", ".fnx45sh[data-fui-focus-visible]:focus-within::after{border-left-style:solid;}", ".f1ljqnps[data-fui-focus-visible]:focus-within::after{border-bottom-style:solid;}", ".fsacsau[data-fui-focus-visible]:focus-within::after{border-top-width:2px;}", ".flcxmxr[data-fui-focus-visible]:focus-within::after{border-right-width:2px;}", ".f138axrn[data-fui-focus-visible]:focus-within::after{border-left-width:2px;}", ".f1f4bc3q[data-fui-focus-visible]:focus-within::after{border-bottom-width:2px;}", ".f5m7f7q[data-fui-focus-visible]:focus-within::after{border-bottom-right-radius:var(--borderRadiusMedium);}", ".f175edhc[data-fui-focus-visible]:focus-within::after{border-bottom-left-radius:var(--borderRadiusMedium);}", ".fhfahiz[data-fui-focus-visible]:focus-within::after{border-top-right-radius:var(--borderRadiusMedium);}", ".fnreirl[data-fui-focus-visible]:focus-within::after{border-top-left-radius:var(--borderRadiusMedium);}", ".fn9i64i[data-fui-focus-visible]:focus-within::after{border-top-color:var(--colorStrokeFocus2);}", ".f1pylbqb[data-fui-focus-visible]:focus-within::after{border-right-color:var(--colorStrokeFocus2);}", ".f3dy9ja[data-fui-focus-visible]:focus-within::after{border-left-color:var(--colorStrokeFocus2);}", ".f1v06qdr[data-fui-focus-visible]:focus-within::after{border-bottom-color:var(--colorStrokeFocus2);}", ".fm1yk70[data-fui-focus-visible]:focus-within::after{top:-2px;}", ".f1itvegt[data-fui-focus-visible]:focus-within::after{bottom:-2px;}", ".f17e4q3j[data-fui-focus-visible]:focus-within::after{left:-2px;}", ".foxjjqz[data-fui-focus-visible]:focus-within::after{right:-2px;}"],
  "f": [".ftqa4ok:focus{outline-style:none;}"],
  "i": [".f2hkw1w:focus-visible{outline-style:none;}"]
});

const useInputStyles = /*#__PURE__*/__styles({
  "base": {
    "qhf8xq": "f1euv43f",
    "oyh7mz": ["f1vgc2s3", "f1e31b4d"],
    "Bhzewxz": "f15twtuk",
    "a9b677": "fly5x3f",
    "Bqenvij": "f1l02sjl",
    "B7ck84d": "f1ewtqcl",
    "B6of3ja": "f1hu3pq6",
    "t21cq0": ["f11qmguv", "f1tyq0we"],
    "jrapky": "f19f4twv",
    "Frg6f3": ["f1tyq0we", "f11qmguv"],
    "abs64n": "fk73vx1",
    "By9lhj9": "fg45n87",
    "G3n25n": "flqpbns",
    "Bojc29n": "fhb1dn5",
    "p8xby4": "fiegpko",
    "Bmzgt9v": "fdi60kf",
    "un08vv": ["fz3jc1r", "f1fwo01y"],
    "Bluxpkm": "f1m2gv5u",
    "upm9ap": ["f1fwo01y", "fz3jc1r"],
    "Bv6ccmg": "ft7ju8s",
    "w6pjei": "f1ofw0le",
    "drfev3": ["fothmfx", "f13qgzgl"],
    "ujr3xk": "fp5vmb3",
    "Bib2mth": ["f13qgzgl", "fothmfx"],
    "za2ojl": "f1snis2b",
    "Bu1fve0": "ff9psms",
    "B42z6en": ["f1fg9ko4", "fqj7xkg"],
    "mosl6v": "f1vebft2",
    "e3wlmb": ["fqj7xkg", "f1fg9ko4"],
    "swj8lc": "f1vtc7ej",
    "kbzjta": "f1fj62aq",
    "Bnazurh": ["fc4i2ph", "f137d5x6"],
    "Enz1qu": "f1v2xs8c",
    "B4rl0r3": ["f137d5x6", "fc4i2ph"],
    "oi7lcb": "f14bpgh5",
    "bwebxt": "f1ariq71",
    "ax4tcq": ["fu58av6", "f1qj5h2v"],
    "z2by79": "fptcwjq",
    "Bpz2hdf": ["f1qj5h2v", "fu58av6"],
    "Btliz3o": "filss48",
    "Bre5bwy": "frtrqgn",
    "Bayw8dt": ["f1v1lrlm", "fapcpph"],
    "lb5vkw": "f49ptgb",
    "yhmu5n": ["fapcpph", "f1v1lrlm"],
    "Blcfbx4": "fgnwcez",
    "yksgid": "f1l3wt4b",
    "B59a1ph": "f16lpvpn",
    "B78hamy": "fdubm5j",
    "t61w4e": ["f11to73e", "f9u8p8h"],
    "Dvncu9": "fw62pkm",
    "qbflri": ["f9u8p8h", "f11to73e"],
    "Byzt4r9": "fqaqzd4"
  },
  "after": {
    "a9b677": "fwr58v7"
  },
  "below": {
    "Bqenvij": "f1je6zif"
  }
}, {
  "d": [".f1euv43f{position:absolute;}", ".f1vgc2s3{left:0;}", ".f1e31b4d{right:0;}", ".f15twtuk{top:0;}", ".fly5x3f{width:100%;}", ".f1l02sjl{height:100%;}", ".f1ewtqcl{box-sizing:border-box;}", ".f1hu3pq6{margin-top:0;}", ".f11qmguv{margin-right:0;}", ".f1tyq0we{margin-left:0;}", ".f19f4twv{margin-bottom:0;}", ".fk73vx1{opacity:0;}", ".fg45n87:enabled{cursor:pointer;}", ".flqpbns:enabled~.fui-Radio__label{cursor:pointer;}", ".fhb1dn5:not(:checked)~.fui-Radio__indicator>*{opacity:0;}", ".fiegpko:enabled:not(:checked)~.fui-Radio__label{color:var(--colorNeutralForeground3);}", ".fdi60kf:enabled:not(:checked)~.fui-Radio__indicator{border-top-color:var(--colorNeutralStrokeAccessible);}", ".fz3jc1r:enabled:not(:checked)~.fui-Radio__indicator{border-right-color:var(--colorNeutralStrokeAccessible);}", ".f1fwo01y:enabled:not(:checked)~.fui-Radio__indicator{border-left-color:var(--colorNeutralStrokeAccessible);}", ".f1m2gv5u:enabled:not(:checked)~.fui-Radio__indicator{border-bottom-color:var(--colorNeutralStrokeAccessible);}", ".ft7ju8s:enabled:not(:checked):hover~.fui-Radio__label{color:var(--colorNeutralForeground2);}", ".f1ofw0le:enabled:not(:checked):hover~.fui-Radio__indicator{border-top-color:var(--colorNeutralStrokeAccessibleHover);}", ".fothmfx:enabled:not(:checked):hover~.fui-Radio__indicator{border-right-color:var(--colorNeutralStrokeAccessibleHover);}", ".f13qgzgl:enabled:not(:checked):hover~.fui-Radio__indicator{border-left-color:var(--colorNeutralStrokeAccessibleHover);}", ".fp5vmb3:enabled:not(:checked):hover~.fui-Radio__indicator{border-bottom-color:var(--colorNeutralStrokeAccessibleHover);}", ".f1snis2b:enabled:not(:checked):hover:active~.fui-Radio__label{color:var(--colorNeutralForeground1);}", ".ff9psms:enabled:not(:checked):hover:active~.fui-Radio__indicator{border-top-color:var(--colorNeutralStrokeAccessiblePressed);}", ".f1fg9ko4:enabled:not(:checked):hover:active~.fui-Radio__indicator{border-right-color:var(--colorNeutralStrokeAccessiblePressed);}", ".fqj7xkg:enabled:not(:checked):hover:active~.fui-Radio__indicator{border-left-color:var(--colorNeutralStrokeAccessiblePressed);}", ".f1vebft2:enabled:not(:checked):hover:active~.fui-Radio__indicator{border-bottom-color:var(--colorNeutralStrokeAccessiblePressed);}", ".f1vtc7ej:enabled:checked~.fui-Radio__label{color:var(--colorNeutralForeground1);}", ".f1fj62aq:enabled:checked~.fui-Radio__indicator{border-top-color:var(--colorCompoundBrandStroke);}", ".fc4i2ph:enabled:checked~.fui-Radio__indicator{border-right-color:var(--colorCompoundBrandStroke);}", ".f137d5x6:enabled:checked~.fui-Radio__indicator{border-left-color:var(--colorCompoundBrandStroke);}", ".f1v2xs8c:enabled:checked~.fui-Radio__indicator{border-bottom-color:var(--colorCompoundBrandStroke);}", ".f14bpgh5:enabled:checked~.fui-Radio__indicator{color:var(--colorCompoundBrandForeground1);}", ".f1ariq71:enabled:checked:hover~.fui-Radio__indicator{border-top-color:var(--colorCompoundBrandStrokeHover);}", ".fu58av6:enabled:checked:hover~.fui-Radio__indicator{border-right-color:var(--colorCompoundBrandStrokeHover);}", ".f1qj5h2v:enabled:checked:hover~.fui-Radio__indicator{border-left-color:var(--colorCompoundBrandStrokeHover);}", ".fptcwjq:enabled:checked:hover~.fui-Radio__indicator{border-bottom-color:var(--colorCompoundBrandStrokeHover);}", ".filss48:enabled:checked:hover~.fui-Radio__indicator{color:var(--colorCompoundBrandForeground1Hover);}", ".frtrqgn:enabled:checked:hover:active~.fui-Radio__indicator{border-top-color:var(--colorCompoundBrandStrokePressed);}", ".f1v1lrlm:enabled:checked:hover:active~.fui-Radio__indicator{border-right-color:var(--colorCompoundBrandStrokePressed);}", ".fapcpph:enabled:checked:hover:active~.fui-Radio__indicator{border-left-color:var(--colorCompoundBrandStrokePressed);}", ".f49ptgb:enabled:checked:hover:active~.fui-Radio__indicator{border-bottom-color:var(--colorCompoundBrandStrokePressed);}", ".fgnwcez:enabled:checked:hover:active~.fui-Radio__indicator{color:var(--colorCompoundBrandForeground1Pressed);}", ".f1l3wt4b:disabled~.fui-Radio__label{color:var(--colorNeutralForegroundDisabled);}", ".f16lpvpn:disabled~.fui-Radio__label{cursor:default;}", ".fdubm5j:disabled~.fui-Radio__indicator{border-top-color:var(--colorNeutralStrokeDisabled);}", ".f11to73e:disabled~.fui-Radio__indicator{border-right-color:var(--colorNeutralStrokeDisabled);}", ".f9u8p8h:disabled~.fui-Radio__indicator{border-left-color:var(--colorNeutralStrokeDisabled);}", ".fw62pkm:disabled~.fui-Radio__indicator{border-bottom-color:var(--colorNeutralStrokeDisabled);}", ".fqaqzd4:disabled~.fui-Radio__indicator{color:var(--colorNeutralForegroundDisabled);}", ".fwr58v7{width:calc(16px + 2 * var(--spacingHorizontalS));}", ".f1je6zif{height:calc(16px + 2 * var(--spacingVerticalS));}"]
});

const useIndicatorStyles = /*#__PURE__*/__styles({
  "base": {
    "a9b677": "fjw5fx7",
    "Bqenvij": "fd461yt",
    "Be2twd7": "f1ugzwwg",
    "B7ck84d": "f1ewtqcl",
    "Bnnss6s": "fi64zpg",
    "mc9l5x": "f22iagw",
    "Bt984gj": "f122n59",
    "Brf1p80": "f4d9j23",
    "B68tc82": "f1p9o1ba",
    "Bmxbyg5": "f1sil6mw",
    "B4j52fo": "f192inf7",
    "Bekrc4i": ["f5tn483", "f1ojsxk5"],
    "Bn0qgzm": "f1vxd6vx",
    "ibv6hh": ["f1ojsxk5", "f5tn483"],
    "icvyot": "fzkkow9",
    "vrafjx": ["fcdblym", "fjik90z"],
    "oivjwe": "fg706s2",
    "wvpqe5": ["fjik90z", "fcdblym"],
    "Bbmb7ep": ["f8fbkgy", "f1nfllo7"],
    "Beyfa6y": ["f1nfllo7", "f8fbkgy"],
    "B7oj6ja": ["f1djnp8u", "f1s8kh49"],
    "Btl43ni": ["f1s8kh49", "f1djnp8u"],
    "B6of3ja": "frnwi6n",
    "t21cq0": ["f1vcna3q", "foyynoy"],
    "jrapky": "fqcjy3b",
    "Frg6f3": ["foyynoy", "f1vcna3q"],
    "Bkfmm31": "f1w9h62z",
    "Bkecrkj": "f1aehjj5"
  }
}, {
  "d": [".fjw5fx7{width:16px;}", ".fd461yt{height:16px;}", ".f1ugzwwg{font-size:12px;}", ".f1ewtqcl{box-sizing:border-box;}", ".fi64zpg{-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;}", ".f22iagw{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}", ".f122n59{-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}", ".f4d9j23{-webkit-box-pack:center;-ms-flex-pack:center;-webkit-justify-content:center;justify-content:center;}", ".f1p9o1ba{overflow-x:hidden;}", ".f1sil6mw{overflow-y:hidden;}", ".f192inf7{border-top-width:var(--strokeWidthThin);}", ".f5tn483{border-right-width:var(--strokeWidthThin);}", ".f1ojsxk5{border-left-width:var(--strokeWidthThin);}", ".f1vxd6vx{border-bottom-width:var(--strokeWidthThin);}", ".fzkkow9{border-top-style:solid;}", ".fcdblym{border-right-style:solid;}", ".fjik90z{border-left-style:solid;}", ".fg706s2{border-bottom-style:solid;}", ".f8fbkgy{border-bottom-right-radius:var(--borderRadiusCircular);}", ".f1nfllo7{border-bottom-left-radius:var(--borderRadiusCircular);}", ".f1djnp8u{border-top-right-radius:var(--borderRadiusCircular);}", ".f1s8kh49{border-top-left-radius:var(--borderRadiusCircular);}", ".frnwi6n{margin-top:var(--spacingVerticalS);}", ".f1vcna3q{margin-right:var(--spacingHorizontalS);}", ".foyynoy{margin-left:var(--spacingHorizontalS);}", ".fqcjy3b{margin-bottom:var(--spacingVerticalS);}", ".f1w9h62z{fill:currentColor;}", ".f1aehjj5{pointer-events:none;}"]
});

const useLabelStyles = /*#__PURE__*/__styles({
  "base": {
    "qb2dma": "f7nlbp4",
    "z8tnut": "f1kwiid1",
    "z189sj": ["f1vdfbxk", "f1f5gg8d"],
    "Byoj8tv": "f5b47ha",
    "uwmqm3": ["f1f5gg8d", "f1vdfbxk"]
  },
  "after": {
    "uwmqm3": ["fruq291", "f7x41pl"],
    "B6of3ja": "fjzwpt6",
    "jrapky": "fh6j2fo"
  },
  "below": {
    "z8tnut": "f1ywm7hm",
    "fsow6f": "f17mccla"
  }
}, {
  "d": [".f7nlbp4{-webkit-align-self:center;-ms-flex-item-align:center;align-self:center;}", ".f1kwiid1{padding-top:var(--spacingVerticalS);}", ".f1vdfbxk{padding-right:var(--spacingHorizontalS);}", ".f1f5gg8d{padding-left:var(--spacingHorizontalS);}", ".f5b47ha{padding-bottom:var(--spacingVerticalS);}", ".fruq291{padding-left:var(--spacingHorizontalXS);}", ".f7x41pl{padding-right:var(--spacingHorizontalXS);}", ".fjzwpt6{margin-top:calc((16px - var(--lineHeightBase300)) / 2);}", ".fh6j2fo{margin-bottom:calc((16px - var(--lineHeightBase300)) / 2);}", ".f1ywm7hm{padding-top:var(--spacingVerticalXS);}", ".f17mccla{text-align:center;}"]
});
/**
 * Apply styling to the Radio slots based on the state
 */


export const useRadioStyles_unstable = state => {
  const {
    labelPosition
  } = state;
  const rootStyles = useRootStyles();
  state.root.className = mergeClasses(radioClassNames.root, rootStyles.base, rootStyles.focusIndicator, labelPosition === 'below' && rootStyles.vertical, state.root.className);
  const inputStyles = useInputStyles();
  state.input.className = mergeClasses(radioClassNames.input, inputStyles.base, inputStyles[labelPosition], state.input.className);
  const indicatorStyles = useIndicatorStyles();
  state.indicator.className = mergeClasses(radioClassNames.indicator, indicatorStyles.base, state.indicator.className);
  const labelStyles = useLabelStyles();

  if (state.label) {
    state.label.className = mergeClasses(radioClassNames.label, labelStyles.base, labelStyles[labelPosition], state.label.className);
  }
};
//# sourceMappingURL=useRadioStyles.js.map